"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { checkMaintenanceMode } from "@/lib/maintenanceMode";

const EXCLUDED_PATHS = ["/maintenance-mode", "/access-denied"];

function normalizePath(pathname = "") {
  const normalized = pathname.replace(/\/$/, "");
  return normalized || "/";
}

export default function MaintenanceGuard() {
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    const currentPath = normalizePath(pathname);

    if (EXCLUDED_PATHS.includes(currentPath)) {
      return undefined;
    }

    let cancelled = false;

    const verifyMaintenanceStatus = async () => {
      const isMaintenanceEnabled = await checkMaintenanceMode();
      if (!cancelled && isMaintenanceEnabled) {
        router.replace("/maintenance-mode");
      }
    };

    verifyMaintenanceStatus();

    return () => {
      cancelled = true;
    };
  }, [pathname, router]);

  return null;
}
